import Model from "../../core/model/Model";
import { INameTranslation } from "../../core/model/translations/NameTranslation";
import ValidatableObject from "../../core/model/validation/ValidatableObject";

export interface TOrganisationIndexCategory {
  id: number;
  name: string;
  indexTypeCategoryId: number;
  organisationId: number;
  valid: boolean;
  nameTranslations: INameTranslation[];
}

export interface IOrganisationIndexCategory
  extends TOrganisationIndexCategory {}

const OrganisationIndexCategory = Model(
  (model: TOrganisationIndexCategory): IOrganisationIndexCategory => {
    const _value: TOrganisationIndexCategory = Object.assign({}, model);

    let _model = {
      get id() {
        return _value.id;
      },
      set id(value) {
        _value.id = value;
      },
      get name() {
        return _value.name;
      },
      set name(value) {
        _value.name = value;
      },
      get indexTypeCategoryId() {
        return _value.indexTypeCategoryId;
      },
      set indexTypeCategoryId(value) {
        _value.indexTypeCategoryId = value;
      },
      get organisationId() {
        return _value.organisationId;
      },
      set organisationId(value) {
        _value.organisationId = value;
      },
      get valid() {
        return _value.valid;
      },
      set valid(value) {
        _value.valid = value;
      },
      get nameTranslations() {
        return _value.nameTranslations;
      },
      set nameTranslations(value) {
        _value.nameTranslations = value;
      }
    };

    return ValidatableObject<IOrganisationIndexCategory>(_model);
  }
);

export default OrganisationIndexCategory;
